import {
  inboundShipmentIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

export const unlinkShipmentFromPurchaseOrder = {
  name: "unlinkShipmentFromPurchaseOrder" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    inboundShipmentId: inboundShipmentIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
